export default {
  dev: {
    name: 'demo-dev',
    appId: 'wx9e5863e1401b768c',
    wechatId: '111',
  },
  stg: {
    name: 'demo-stg',
    appId: 'wx9e5863e1401b768c',
    wechatId: '222',
  },
  prod: {
    name: 'demo-prod',
    appId: 'wx9e5863e1401b768c',
    wechatId: '333',
  }
};